/**
 * TeamSystem Impact - Frontend Logger
 * Structured logger wrapping console with level filtering.
 * In production: only warn and error are logged.
 * In development: all levels are enabled.
 */

const isDev = import.meta.env.DEV;

export const logger = {
  debug: (...args: unknown[]) => { if (isDev) console.debug('[DEBUG]', ...args); },
  info: (...args: unknown[]) => { if (isDev) console.info('[INFO]', ...args); },
  warn: (...args: unknown[]) => { console.warn('[WARN]', ...args); },
  error: (...args: unknown[]) => { console.error('[ERROR]', ...args); },
};
